const getNavigationItemIcon = (navigationItem) => {
  if (navigationItem.page) {
    return { id: 'page', label: 'Page' };
  }

  if (navigationItem.link) {
    return { id: 'linkout2', label: 'Link out' };
  }

  return undefined;
};

export default getNavigationItemIcon;
